<span
  *ngIf="badge as config; else noStatus"
  class="expense-badge"
  [ngClass]="'expense-badge--' + config.variant"
>
  {{ config.labelKey | translate }}
</span>

<ng-template #noStatus>
  <span class="expense-badge-empty">{{ 'expenses.no_value' | translate }}</span>
</ng-template>
